import React, { useEffect, useState } from "react";
import Logo from "../../Image/Logo.jpg";
import { useDispatch, useSelector } from "react-redux";
import { getBranchAction } from "../../Actions/BranchAction/BranchAction";
import { useNavigate } from "react-router-dom";
import LoadingPage from "../Loading/LoadingPage";

import Modal from "../../Modal/Modal";
import PositionModal from "../../Modal/PositionModal";

const Dashboard = ({ userAuth }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getBranchAction());
  }, []);
  
  const [branchList, setBranchList] = useState([]);
  const [positionList, setPositionList] = useState([]);
  useEffect(() => {
    let tempBranchId = [];
    let tempPositionId = [];
    userAuth?.user_info?.privilges?.map((previlige) => {
      
      tempBranchId.push(previlige.branch_id);
      tempPositionId.push(previlige.position_id);
      setBranchList(tempBranchId);
      setPositionList(tempPositionId);
    });
  }, [userAuth]);
  const getBranch = useSelector((state) => state.getBranch);
  const { branches, loading: loadingBranch } = getBranch;
  const navigate = useNavigate();


  const [isOpenPosition, setIsOpenPosition] = useState(true);
  const isPosition = localStorage.getItem("position");
  useEffect(() => {
    if (isPosition) {
      setIsOpenPosition(false);
    } else {
      setIsOpenPosition(true);
    }
  }, [isPosition, userAuth]);
  return (
    <React.Fragment>
      {loadingBranch || !userAuth || userAuth == undefined ? (
        <LoadingPage />
      ) : (
        <React.Fragment>
          {userAuth && (
            <div className="flex h-screen ">
              <div className="flex-1 bg-gray-200 p-8">
                <div className="flex gap-2 justify-between items-center">
                  <h2 className="text-2xl font-semibold mb-4">Dashboard</h2>
                  <div className="font-bold">
                    Welcome : {userAuth?.user_info?.en_name}
                  </div>
                </div>
              
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                  {branches.map((branch, index) => (
                    <>
                      {branchList.includes(branch.id) && (
                        <div
                          key={index}
                          className="bg-white p-4 rounded-md cursor-pointer shadow-md flex  gap-5 items-center"
                          title={branch.name}
                          onClick={() => {
                            navigate("/yourProfile");
                            localStorage.setItem("branch_id", branch.id);
                          }}
                        >
                          <img src={Logo} className="w-20" alt="" />
                          {/* <span className="mr-4">{branch.icon}</span> */}
                          <div>
                            <h3 className="text-lg font-semibold mb-2">
                              {branch.name}
                            </h3>
                          </div>
                        </div>
                      )}
                    </>
                  ))}
                </div>
              </div>
            </div>
          )}
        </React.Fragment>
      )}
      <Modal
        width={"w-2/12"}
        isOpen={isOpenPosition}
        closeModal={() => setIsOpenPosition(false)}
      >
        <PositionModal
          positionList={positionList}
          isOpen={isOpenPosition}
          onClose={() => setIsOpenPosition(false)}
          user={userAuth}
        />
      </Modal>
    </React.Fragment>
  );
};

export default Dashboard;
